export default __webpack_public_path__ + "static/media/pages-active.af4d8435.svg";